<template>
    <div class="w-full flex flex-column gap-2">
        <div v-if="headerTxt" class="w-full flex flex-row">
            <span class="text-sm text-600">{{ headerTxt }}</span>
        </div>
        <div class="w-full flex flex-column border-round-3xl p-0 overflow-hidden"
            :class="(colorType=='white') ? 'surface-0' : 'surface-100'">
            <div v-for="(item, i) of items" class="w-full flex flex-row px-3 py-2 cursor-pointer" :key="i"
                v-if="items && items.length > 0"
                @click="go(item.href)" 
                :style="(size=='medium') ? 'min-height:60px' : 'min-height:50px'"
                :class="(i==items.length-1) ? 'border-bottom-0' : 'border-bottom-1', (colorType=='white') ? 'border-100' : 'border-200'" >
                <div v-if="item.labelIcon" class="flex mr-3 align-items-center">
                    <Avatar class="text-600" size="small" :icon="item.labelIcon" shape="circle"/>
                </div>
                <div class="flex flex-1 justify-content-left align-items-center">
                    <span v-if="item.label" class="text-600">{{ item.label[lang] }}</span>
                </div>
                <div class="flex justify-content-right align-items-center">
                    <span v-if="item.btnText" class="text-sm text-blue-500">{{ item.btnText }}</span>
                    <i v-if="item.btnIcon" class="text-blue-500 ml-2" :class="item.btnIcon" />
                </div>
            </div>
            <slot name="body"></slot>
        </div>
        <div v-if="footerTxt" class="w-full mb-1 flex flex-row">
            <span class="text-xs text-600">{{ footerTxt }}</span>
        </div>
    </div>
</template>

<script>
import Connect from         '@/assets/js/Connect.js'
import Helper from          '@/assets/js/Helper.js'

export default {
    props: {
        headerTxt: {
            type: String,
            default: null
        },
        items: {
            type: Array,
            default: []
        },
        size: {
            type: String,
            default: 'small'
        },
        footerTxt: {
            type: String,
            default: null
        },
        colorType: {
            type: String,
            default: 'white'
        }
    },
    data(){
        return {}
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    methods: {
        go(href){
            if(!href) return 
            this.$emit('go', href)
            this.$router.push({path: href})
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },

}
</script>